<template>
    <CloudQuickPrinting v-if="isMobile"></CloudQuickPrinting>
    <ShopSelfPrintingPc v-else></ShopSelfPrintingPc>
</template>

<script>
import ShopSelfPrintingPc from './ShopSelfPrintingPc.vue';
import CloudQuickPrinting from './H5/CloudQuickPrinting.vue';
export default {
components: {
    ShopSelfPrintingPc,
    CloudQuickPrinting,
},
data() {
    return {
        isMobile: true,
    }
},
created() {
    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
    );
},
mounted() {
    window.scrollTo(0, 0);
},
methods: {

},
};
</script>


// WEBPACK FOOTER //
// src/components/ShopSelfPrinting.vue